// src/services/githubApi.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const githubApi = createApi({
  reducerPath: "githubApi",
  baseQuery: createCustomBaseQuery(
    `${API_BASE_URL}/github/`
  ),
  tagTypes: ["GitHub"],
  endpoints: (builder) => ({
    initiateGithubLogin: builder.mutation<any, { project_id?: string }>({
      query: ({ project_id }) => ({
        url: project_id
          ? `login/github?project_id=${encodeURIComponent(project_id)}`
          : "login/github",
        method: "GET",
      }),
    }),

    getOrganizations: builder.query<any, void>({
      query: () => "github/organizations",
      providesTags: ["GitHub"],
    }),

    createGithubRepo: builder.mutation<any, any>({
      query: (body) => ({
        url: "repos",
        method: "POST",
        body,
      }),
    }),

    getRepoCommits: builder.query<any, any>({
      query: ({ owner, repo_name, branch }) => ({
        url: `github/repos/${owner}/${repo_name}/commits${
          branch ? `?branch=${branch}` : ""
        }`,
      }),
    }),

    revertCommit: builder.mutation<any, any>({
      query: ({ owner, repo_name, target_commit_sha }) => ({
        url: `github/repos/${owner}/${repo_name}/revert?target_commit_sha=${target_commit_sha}`,
        method: "POST",
      }),
      invalidatesTags: ["GitHub"],
    }),

    disconnectGithub: builder.mutation<any, { project_id: string }>({
      query: ({ project_id }) => ({
        url: `projects/${encodeURIComponent(project_id)}/github/disconnect`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useInitiateGithubLoginMutation,
  useGetOrganizationsQuery,
  useCreateGithubRepoMutation,
  useGetRepoCommitsQuery,
  useRevertCommitMutation,
  useDisconnectGithubMutation,
} = githubApi;
